import { render, staticRenderFns } from "./Tariffs.vue?vue&type=template&id=7dd25a5e&scoped=true"
import script from "./Tariffs.vue?vue&type=script&lang=js"
export * from "./Tariffs.vue?vue&type=script&lang=js"
import style0 from "./Tariffs.vue?vue&type=style&index=0&id=7dd25a5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd25a5e",
  null
  
)

export default component.exports